<template>
  <Transition name="dialog">
    <div
      v-if="show"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 px-6"
      @click.self="handleClose"
    >
      <div
        class="bg-white rounded-3xl p-6 max-w-sm w-full shadow-xl"
        @click.stop
      >
        <div class="text-center mb-5">
          <div class="text-2xl mb-2">📅</div>
          <h3 class="font-bold text-lg text-textMain">選擇行事曆</h3>
        </div>

        <div class="space-y-3 mb-4">
          <button
            @click="handleChoose('google')"
            class="w-full bg-white border-2 border-gray-200 py-3 rounded-xl active:scale-[0.98] transition-transform flex items-center gap-3 px-4"
          >
            <span class="text-xl">🗓️</span>
            <div class="text-left">
              <p class="font-bold text-textMain text-sm">Google 行事曆</p>
              <p class="text-xs text-textMuted">開啟 Google Calendar 網頁新增事件</p>
            </div>
          </button>

          <button
            @click="handleChoose('apple')"
            class="w-full bg-white border-2 border-gray-200 py-3 rounded-xl active:scale-[0.98] transition-transform flex items-center gap-3 px-4"
          >
            <span class="text-xl">📅</span>
            <div class="text-left">
              <p class="font-bold text-textMain text-sm">Apple 行事曆</p>
              <p class="text-xs text-textMuted">透過系統分享匯入 Apple 行事曆</p>
            </div>
          </button>
        </div>

        <p class="text-xs text-textMuted text-center leading-relaxed mb-2">
          之後可在「設定」中修改偏好
        </p>

        <button
          @click="handleClose"
          class="w-full text-textMuted font-bold py-2.5 active:opacity-60 transition-opacity text-sm"
        >
          取消
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  close: []
  choose: [provider: 'google' | 'apple']
}>()

const handleChoose = (provider: 'google' | 'apple') => {
  emit('choose', provider)
}

const handleClose = () => {
  emit('close')
}
</script>

<style scoped>
.dialog-enter-active,
.dialog-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
}

.dialog-enter-active .bg-white,
.dialog-leave-active .bg-white {
  transition: transform 0.3s ease;
}

.dialog-enter-from .bg-white,
.dialog-leave-to .bg-white {
  transform: scale(0.95);
}
</style>
